<script>
import {
  DeleteOutlined, LeftOutlined, RightOutlined, ZoomInOutlined, CloseOutlined,
  UploadOutlined,
} from '@ant-design/icons-vue';
import DraggableResizableVue from 'draggable-resizable-vue3';
import { mapActions, mapState } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import UploadImages from '@/components/ux/upload/Upload-images.vue';
import bem from '@/utils/bem';
import TemplateFrameOptionPersonalizeSettings from '@/components/frames/TemplateFrameOptionPersonalizeSettings.vue';
import TemplateFrameOptionDisplaySettings from '@/components/frames/TemplateFrameOptionDisplaySettings.vue';
import TemplateFrameImageOptionsSettings from '@/components/frames/TemplateFrameImageOptionsSettings.vue';

const b = bem('template-frame-option-displays');

export default {
  data() {
    return {
      selectedDisplay: {},
      name: 'Display name',
      display: {
        framePosition: {
          x: 0, y: 0, width: 200, height: 200, active: false,
        },
        fullDisplay: {
          x: 0, y: 0, width: 1026, height: 600, active: false,
        },
        liveDisplay: {
          x: 10, y: 10, width: 855, height: 500, active: false,
        },
        minDisplay: {
          x: 20, y: 20, width: 607, height: 500, active: false,
        },
        mobileDisplay: {
          x: 30, y: 30, width: 399, height: 300, active: false,
        },
        frameImageOptions: [{
          x: 0, y: 0, width: 100, height: 100, active: false, id: uuidv4(), imageId: null,
        }],
      },
      displayList: [{ value: 'liveDisplay', label: 'Wizard' }, { value: 'minDisplay', label: 'Cards' }, { value: 'mobileDisplay', label: 'Mobile' }, { value: 'framePosition', label: 'Frame' }],
      frameActive: true,
      frameImageUri: {
        file: null,
        url: '',
      },
      baseImageUri: {
        file: null,
        url: '',
      },
      showModal: false,
      imageType: '',
      files: [],
      otherSettings: {
        frameRotateX: 0,
        frameRotateY: 0,
        frameRotateZ: 0,
        framePerspective: 0,
        framePerspectiveOriginX: 0,
        framePerspectiveOriginY: 0,
      },
      activeType: {
        type: '',
        name: '',
        imageOptionId: 0,
      },
      options: [],
      isShowOptions: true,
      frameDisplayPersonalize: [],
      selectedPersonalize: {},
      scale: 1,
      zoomLeft: 0,
      zoomTop: 0,
      isTable: false,
      isDefault: false,
      isRatioLocked: false,
      isInputFocus: false,
      position: '',
      draggedIndex: null,
      dragOverIndex: null,
      isSettingsDrawerOpen: false,
    };
  },
  props: {
    toggleOptionDisplays: {
      type: Function,
      required: true,
    },
    selectedOption: {
      type: Object,
      required: true,
    },
  },
  components: {
    LeftOutlined,
    RightOutlined,
    CloseOutlined,
    TemplateFrameImageOptionsSettings,
    TemplateFrameOptionDisplaySettings,
    TemplateFrameOptionPersonalizeSettings,
    DeleteOutlined,
    DraggableResizableVue,
    UploadImages,
    ZoomInOutlined,
    UploadOutlined,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      updateOrCreateFrameDisplayAction: 'createTemplate/updateOrCreateFrameDisplay',
      updateFrameDisplayPersonalizeAction: 'createTemplate/updateFrameDisplayPersonalize',
      createFrameDisplayPersonalizeAction: 'createTemplate/createFrameDisplayPersonalize',
      deleteFrameDisplayAction: 'createTemplate/deleteFrameDisplay',
      deleteFrameDisplayPersonalizeAction: 'createTemplate/deleteFrameDisplayPersonalize',
      updateDisplayPositionAction: 'createTemplate/updateDisplayPosition',
    }),
    selectDisplay(value) {
      this.selectedDisplay = value;
      const {
        fullDisplay,
        liveDisplay,
        minDisplay,
        mobileDisplay,
        frameImageOptions,
        frameDisplayPersonalize: frameDisplayPersonalizeNotSorted,
        isTable,
        isDefault,
        position,
      } = value;
      const frameDisplayPersonalize = (frameDisplayPersonalizeNotSorted || [])
        .map((itm, index) => ({ ...itm, order: itm.order ?? index }))
        .sort((a, c) => a.order - c.order);
      const newFramePosition = {
        x: Math.round(1026 * (fullDisplay.frameLeft / 100)),
        y: Math.round(600 * (fullDisplay.frameTop / 100)),
        width: Math.round(1026 * (fullDisplay.frameScaleX / 100)),
        height: Math.round(600 * (fullDisplay.frameScale / 100)),
      };
      this.display = {
        framePosition: newFramePosition,
        fullDisplay: this.setLayerSettings('fullDisplay', fullDisplay),
        liveDisplay: this.setLayerSettings('liveDisplay', liveDisplay),
        minDisplay: this.setLayerSettings('minDisplay', minDisplay),
        mobileDisplay: this.setLayerSettings('mobileDisplay', mobileDisplay),
        frameImageOptions: this.setFrameImageOptions(frameImageOptions, newFramePosition),
      };
      this.frameImageUri = {
        file: null,
        url: value.frameImageUri,
      };
      this.baseImageUri = {
        file: null,
        url: value.baseImageUri,
      };
      this.otherSettings = {
        frameRotateX: value.liveDisplay.frameRotateX,
        frameRotateY: value.liveDisplay.frameRotateY,
        frameRotateZ: value.liveDisplay.frameRotateZ,
        framePerspective: value.liveDisplay.framePerspective,
        framePerspectiveOriginX: value.liveDisplay.framePerspectiveOrigin.slice(0, 2).replaceAll('%', ''),
        framePerspectiveOriginY: value.liveDisplay.framePerspectiveOrigin.slice(4, 6).replaceAll('%', ''),
      };
      this.name = value.name;
      this.frameDisplayPersonalize = this.setFrameOptionPersonalize(
        frameDisplayPersonalize,
        newFramePosition,
      );
      this.isTable = isTable;
      this.isDefault = isDefault;
      this.position = position;
    },
    setLayerSettings(type, display) {
      if (display && Object.keys(display).length > 0) {
        return {
          x: Math.round(display.cropX),
          y: Math.round(display.cropY),
          width: Math.round(display.frameWidth),
          height: Math.round(display.frameHeight),
          active: false,
        };
      }
      return this.display[type];
    },
    setFrameImageOptions(options, framePosition) {
      return options.map((item) => ({
        x: Math.round((framePosition.width / 100) * item.x),
        y: Math.round((framePosition.height / 100) * item.y),
        width: Math.round((framePosition.width / 100) * item.width),
        height: Math.round((framePosition.height / 100) * item.height),
        active: false,
        id: uuidv4(),
        imageId: item.imageId || null,
      }));
    },
    setFrameOptionPersonalize(personalizes, framePosition) {
      return personalizes.map((item) => {
        const width = Math.round((framePosition.width / 100) * item.personalizeDisplayDate.scaleX);
        const height = Math.round((framePosition.height / 100) * item.personalizeDisplayDate.scale);
        const personalizeHeight = 600 / (item.frameDisplayData.backgroundScale / 100);
        const personalizeWidth = personalizeHeight * 1.71;
        return ({
          ...item,
          name: item.name || 'Zone name',
          x: Math.round((framePosition.width / 100) * item.personalizeDisplayDate.left),
          y: Math.round((framePosition.height / 100) * item.personalizeDisplayDate.top),
          width,
          height,
          active: false,
          id: item.id,
          lines: item.defaultText ? item.defaultText.split('@@@@@').map((itm, index) => ({
            value: itm,
            id: index + 1,
            placeholder: item?.linesPlaceholder?.[index] || 'Enter your text here',
            isTextArea: item?.linesIsTextArea?.[index] || false,
          })) : [{
            value: '', id: 1, placeholder: 'Enter your text here', isTextArea: false,
          }],
          isPersonalizeDisplayPreview: Boolean(item.isPersonalizeDisplayPreview),
          isPersonalizeActive: Boolean(item.isPersonalizeActive),
          isRequired: Boolean(item.isRequired),
          isUppercase: Boolean(item.isUppercase),
          framePersonalizeOptions: {
            x: Math.round((width / 100) * item.framePersonalizeOptions.x),
            y: Math.round((height / 100) * item.framePersonalizeOptions.y),
            width: Math.round((width / 100) * item.framePersonalizeOptions.width),
            height: Math.round((height / 100) * item.framePersonalizeOptions.height),
          },
          frameDisplayData: {
            ...item.frameDisplayData,
            x: Number(((personalizeWidth / 100) * item.frameDisplayData.backgroundLeft).toFixed(2)),
            y: Number(((personalizeHeight / 100) * item.frameDisplayData.backgroundTop).toFixed(2)),
            width: Number(personalizeWidth.toFixed(2)),
            height: Number(personalizeHeight.toFixed(2)),
          },
        });
      });
    },
    deleteDisplay(id) {
      this.deleteFrameDisplayAction({
        id,
        productId: this.selectedOption.id,
      });
    },
    toggleModal(value, type) {
      this.showModal = value;
      this.imageType = type;
    },
    addImage() {
      const image = this.files[0];
      this[this.imageType] = image;
      if (this.imageType === 'frameImageUri') {
        const imageTag = document.createElement('img');
        imageTag.src = image.url;
        imageTag.addEventListener('load', () => {
          this.display = {
            ...this.display,
            framePosition: {
              ...this.display.framePosition,
              width: Math.round(300 * (imageTag.width / imageTag.height)),
              height: 300,
            },
          };
        });
      }
      this.showModal = false;
    },
    saveDisplay() {
      const display = {
        name: this.name,
        fullDisplay: this.calculateDisplay('fullDisplay'),
        liveDisplay: this.calculateDisplay('liveDisplay'),
        minDisplay: this.calculateDisplay('minDisplay'),
        mobileDisplay: this.calculateDisplay('mobileDisplay'),
        frameImageOptions: this.calculateFrameImageOptions(),
        isTable: this.isTable,
        isDefault: this.isDefault,
        position: this.position,
      };
      this.updateOrCreateFrameDisplayAction({
        display,
        frameImageUri: this.frameImageUri,
        baseImageUri: this.baseImageUri,
        id: this.selectedDisplay.id,
        productId: this.selectedOption.id,
      });
    },
    createDisplay() {
      const display = {
        name: this.name,
        fullDisplay: this.calculateDisplay('fullDisplay'),
        liveDisplay: this.calculateDisplay('liveDisplay'),
        minDisplay: this.calculateDisplay('minDisplay'),
        mobileDisplay: this.calculateDisplay('mobileDisplay'),
        frameImageOptions: this.calculateFrameImageOptions(),
        productId: this.selectedOption.id,
        isTable: this.isTable,
        isDefault: this.isDefault,
        position: this.frameOptionDisplays.length + 1,
      };
      this.updateOrCreateFrameDisplayAction({
        display,
        frameImageUri: this.frameImageUri,
        baseImageUri: this.baseImageUri,
        productId: this.selectedOption.id,
      });
    },
    calculateDisplay(type) {
      return {
        frameTop: (
          (this.display.framePosition.y - this.display[type].y) / this.display[type].height
        ) * 100,
        frameLeft: (
          (this.display.framePosition.x - this.display[type].x) / this.display[type].width
        ) * 100,
        frameScale: (this.display.framePosition.height / this.display[type].height) * 100,
        frameScaleX: (this.display.framePosition.width / this.display[type].width) * 100,
        frameRotateX: this.otherSettings.frameRotateX,
        frameRotateY: this.otherSettings.frameRotateY,
        frameRotateZ: this.otherSettings.frameRotateZ,
        framePerspective: this.otherSettings.framePerspective,
        framePerspectiveOrigin: `${this.otherSettings.framePerspectiveOriginX}% ${this.otherSettings.framePerspectiveOriginY}%`,
        frameWidth: Math.round(this.display[type].width),
        frameHeight: Math.round(this.display[type].height),
        cropX: this.display[type].x,
        cropY: this.display[type].y,
        backgroundScale: (600 / this.display[type].height) * 100,
        backgroundLeft: (this.display[type].x / this.display[type].width) * 100,
        backgroundTop: (this.display[type].y / this.display[type].height) * 100,
      };
    },
    calculateFrameImageOptions() {
      return this.display.frameImageOptions.map((item) => {
        const newItem = {
          x: (item.x / this.display.framePosition.width) * 100,
          y: (item.y / this.display.framePosition.height) * 100,
          width: (item.width / this.display.framePosition.width) * 100,
          height: (item.height / this.display.framePosition.height) * 100,
        };
        if (this.display.frameImageOptions.length > 1) {
          newItem.id = item.id;
          newItem.imageId = item.imageId || null;
        }
        return newItem;
      });
    },
    addFrameImageViewBox() {
      this.display = {
        ...this.display,
        frameImageOptions: [...this.display.frameImageOptions, {
          x: 0,
          y: 0,
          width: 100,
          height: 100,
          active: false,
          id: uuidv4(),
        }],
      };
    },
    removeFrameImageViewBox(id) {
      this.display = {
        ...this.display,
        frameImageOptions: this.display.frameImageOptions.filter((item) => item.id !== id),
      };
    },
    setActiveType(value, id) {
      let name = 'Frame';
      if (value === 'liveDisplay') {
        name = 'Wizard';
      }
      if (value === 'minDisplay') {
        name = 'Cards';
      }
      if (value === 'mobileDisplay') {
        name = 'Mobile';
      }
      if (value === 'frameImageOptions') {
        name = 'View box';
      }
      this.activeType = {
        type: value,
        name,
        imageOptionId: value === 'frameImageOptions' ? id : 0,
      };
      this.isSettingsDrawerOpen = true;
    },
    closeSettingsDrawer() {
      this.isSettingsDrawerOpen = false;
    },
    onDragImageOption(x, y, value) {
      this.display = {
        ...this.display,
        frameImageOptions: this.display.frameImageOptions.map((item) => {
          if (item.id === value && (x !== 0 || y !== 0)) {
            return {
              ...item,
              x,
              y,
            };
          }
          return item;
        }),
      };
    },
    changeSelectedOption(_, option) {
      this.toggleOptionDisplays(false, option.item);
    },
    selectPersonalize(value) {
      this.selectedPersonalize = value;
      this.isSettingsDrawerOpen = true;
    },
    addPersonalize() {
      this.frameDisplayPersonalize = [...this.frameDisplayPersonalize, {
        x: 20,
        y: 20,
        width: 129,
        height: 100,
        active: false,
        id: uuidv4(),
        name: 'Zone name',
        lines: [{ value: 'Default text', id: 1 }],
        isPersonalizeDisplayPreview: false,
        isPersonalizeActive: false,
        isRequired: false,
        isUppercase: false,
        framePersonalizeOptions: {
          x: 0,
          y: 20,
          width: 100,
          height: 50,
        },
        fontFamily: 'Work Sans',
        fontWeight: 400,
        fontSize: 20,
        characterLimit: 15,
        lineLimit: 1,
        fontColor: '#000',
        isNew: true,
        frameDisplayData: {
          active: false,
          x: 100,
          y: 200,
          width: 513,
          height: 300,
        },
      }];
    },
    selectPersonalizeScale(item) {
      const { fullDisplay } = this.display;
      const {
        x, y, width, height,
      } = item.frameDisplayData;
      if (this.scale === 1) {
        this.scale = fullDisplay.height / height;
        this.zoomLeft = (fullDisplay.width / 2 - x) - width / 2;
        this.zoomTop = (fullDisplay.height / 2 - y) - height / 2;
      } else {
        this.resetScale();
      }
      this.isSettingsDrawerOpen = true;
    },
    savePersonalize() {
      this.frameDisplayPersonalize.forEach((item, index) => {
        const newFrameDisplayPersonalize = {
          id: item.isNew ? this.selectedDisplay.id : item.id,
          name: item.name,
          order: item.order || index,
          characterLimit: item.characterLimit,
          fontColor: item.fontColor,
          fontFamily: item.fontFamily,
          fontSize: item.fontSize,
          fontWeight: item.fontWeight,
          alignment: item.alignment || 'center',
          verticalAlignment: item.verticalAlignment || 'center',
          placeholder: item.placeholder || 'Enter your text here',
          isPersonalizeDisplayPreview: item.isPersonalizeDisplayPreview,
          isPersonalizeActive: item.isPersonalizeActive,
          isRequired: item.isRequired,
          isUppercase: item.isUppercase,
          lineLimit: item.lineLimit,
          linesPlaceholder: item.lines.map((itm) => itm.placeholder || 'Enter your text here'),
          linesIsTextArea: item.lines.map((itm) => itm.isTextArea || false),
          defaultText: item.lines.reduce((acc, text) => {
            if (acc) {
              return `${acc}@@@@@${text.value}`;
            } return `${text.value}`;
          }, ''),
          personalizeDisplayDate: {
            left: Number(((item.x / this.display.framePosition.width) * 100).toFixed(2)),
            top: Number(((item.y / this.display.framePosition.height) * 100).toFixed(2)),
            rotateX: this.otherSettings.frameRotateX,
            rotateY: this.otherSettings.frameRotateY,
            rotateZ: this.otherSettings.frameRotateZ,
            scale: Number(((item.height / this.display.framePosition.height) * 100).toFixed(2)),
            scaleX: Number(((item.width / this.display.framePosition.width) * 100).toFixed(2)),
          },
          framePersonalizeOptions: {
            x: Number(((item.framePersonalizeOptions.x / item.width) * 100).toFixed(2)),
            y: Number(((item.framePersonalizeOptions.y / item.height) * 100).toFixed(2)),
            width: Number(((item.framePersonalizeOptions.width / item.width) * 100).toFixed(2)),
            height: Number(((item.framePersonalizeOptions.height / item.height) * 100).toFixed(2)),
          },
          frameDisplayData: {
            frameTop: (
              (this.display.framePosition.y - item.frameDisplayData.y)
              / item.frameDisplayData.height
            ) * 100,
            frameLeft: (
              (this.display.framePosition.x - item.frameDisplayData.x) / item.frameDisplayData.width
            ) * 100,
            frameScale: (this.display.framePosition.height / item.frameDisplayData.height) * 100,
            frameScaleX: (this.display.framePosition.width / item.frameDisplayData.width) * 100,
            backgroundScale: (600 / item.frameDisplayData.height) * 100,
            backgroundLeft: (item.frameDisplayData.x / item.frameDisplayData.width) * 100,
            backgroundTop: (item.frameDisplayData.y / item.frameDisplayData.height) * 100,
          },
        };
        if (item.isNew) {
          this.createFrameDisplayPersonalizeAction(newFrameDisplayPersonalize);
        } else {
          this.updateFrameDisplayPersonalizeAction(newFrameDisplayPersonalize);
        }
      });
    },
    resetScale() {
      this.scale = 1;
      this.zoomLeft = 0;
      this.zoomTop = 0;
    },
    deletePersonalize({ id, isNew }) {
      this.selectedPersonalize = {};
      this.frameDisplayPersonalize = this.frameDisplayPersonalize.filter((item) => item.id !== id);
      if (!isNew) {
        this.deleteFrameDisplayPersonalizeAction({ id });
      }
    },
    personalizeOnChange(value, changeType) {
      this.frameDisplayPersonalize = this.frameDisplayPersonalize.map((item) => {
        if (item.id === this.selectedPersonalize.id) {
          if (changeType === 'personalizeData') {
            const {
              handle,
              width,
              x,
              y,
              height,
            } = value;
            const type = handle === 'bm' || handle === 'tm' ? 'height' : 'width';
            const newValue = type === 'width' ? width / 1.71 : height * 1.71;
            return {
              ...item,
              frameDisplayData: {
                ...item.frameDisplayData,
                x,
                y,
                width: Math.round(type === 'width' ? width : newValue),
                height: Math.round(type === 'height' ? height : newValue),
              },
            };
          }
          const { type, value: newValue } = value;
          return {
            ...item,
            [type]: newValue,
            lines: item[type] < newValue
              ? [...item.lines, ...Array.from({ length: newValue - item[type] }, () => ({ id: uuidv4(), value: 'default text' }))]
              : item.lines.slice(0, item.lines.length - (item[type] - newValue)),
          };
        }
        return item;
      });
    },
    setPersonalizeOptionsActive() {
    },
    getBackgroundImage(id) {
      if (this.frameDetails?.name === 'collage') {
        const image = this.collagePreviewImage.find((item) => item.id === id);
        return image?.imageUrl || '';
      }
      return '';
    },
    onResizingDisplay(handle, x, y, width, height) {
      this.display = {
        ...this.display,
        [this.activeType.type]: {
          ...this.display[this.activeType.type],
          x,
          y,
          width,
          height,
        },
      };
    },
    onResizingFrame(handle, x, y, width, height) {
      if (handle === 'bm' || handle === 'mr') {
        this.display = {
          ...this.display,
          framePosition: {
            x,
            y,
            width,
            height,
          },
        };
      }
    },
    updateDisplayPosition(value) {
      const payload = { productId: this.selectedOption.id, displays: [...value] };
      this.updateDisplayPositionAction(payload);
    },
    onPersonalizeDragStart(index) {
      this.draggedIndex = index;
    },
    onPersonalizeDragOver(e, index) {
      e.preventDefault();
      this.dragOverIndex = index;
    },
    onPersonalizeDragLeave() {
      this.dragOverIndex = null;
    },
    onPersonalizeDrop(e, dropIndex) {
      e.preventDefault();
      if (this.draggedIndex === null || this.draggedIndex === dropIndex) {
        this.draggedIndex = null;
        this.dragOverIndex = null;
        return;
      }

      const reorderedList = [...this.frameDisplayPersonalize];
      const [draggedItem] = reorderedList.splice(this.draggedIndex, 1);
      reorderedList.splice(dropIndex, 0, draggedItem);

      this.frameDisplayPersonalize = reorderedList.map((item, index) => ({
        ...item,
        order: index,
      }));

      this.draggedIndex = null;
      this.dragOverIndex = null;
    },
  },
  watch: {
    display: {
      handler(newVal) {
        const isFrameActive = newVal.frameImageOptions.some((item) => item.active);
        this.frameActive = !isFrameActive;
      },
      deep: true,
    },
    isShowOptions(newVal) {
      if (newVal) {
        this.resetScale();
      }
    },
  },
  computed: {
    ...mapState({
      frameOptions: (state) => state.createTemplate.frameOptions,
      frameOptionDisplays: (state) => state.createTemplate.frameOptionDisplays,
      collagePreviewImage: (state) => state.createTemplate.collagePreviewImage,
      frameDetails: (state) => state.createTemplate.frameDetails,
    }),
    drawerTitle() {
      const hasPersonalize = Object.keys(this.selectedPersonalize).length > 0;
      if (!this.isShowOptions && hasPersonalize) {
        return 'Personalize Settings';
      }
      return 'Layer Settings';
    },
  },
  mounted() {
    this.options = this.frameOptions.map((item) => ({
      label: `${item.frameSize.name} - ${item.frameColor.name} - ${item.frameOrientation}`,
      value: item.id,
      item,
    }));
  },
};
</script>

<template>
  <div :class="b('')">
    <div :class="b('left-side')">
      <div :class="b('back-btn')">
        <a-button type="primary" @click="toggleOptionDisplays(true, {})">
          Go to options
        </a-button>
        <div :class="b('toggle')">
          <span :class="b('input-title')">Layers or personalize</span>
          <a-switch
              checked-children="Layers"
              un-checked-children="Personalize"
              v-model:checked="isShowOptions"
          />
        </div>
      </div>
      <div
        v-if="selectedOption?.frameSize && selectedOption?.frameColor"
        :class="b('option-selector')"
      >
        <span :class="b('option-selector-label')">Selected Option</span>
        <a-select
            style="width: 100%"
            :value="{
                label: `${selectedOption.frameSize.name}
                - ${selectedOption.frameColor.name}
                - ${selectedOption.frameOrientation}`,
                value: selectedOption.id,
                selectedOption,
              }"
            :options="options"
            @change="changeSelectedOption"
        />
      </div>
      <div :class="b('display-info')">
        <div :class="b('display-list')">
          <button
              :class="b('display', { selected: selectedDisplay.id === item.id })"
              v-for="(item, index) in frameOptionDisplays"
              :key="item.id"
              @click="selectDisplay(item)"
          >
            <img :class="b('display-image')" :src="item.baseImageUri" alt="display image">
            <span :class="b('display-name')">{{ item.name }}</span>
            <span :class="b('display-delete-btn')">
              <a-popconfirm title="Sure to delete?" @confirm="deleteDisplay(item.id)">
                <a-button type="primary" size="small" html-type="button" danger>
                  <DeleteOutlined />
                </a-button>
              </a-popconfirm>
            </span>
            <span :class="b('display-position-buttons', {
              firstDisplay: index === 0,
              lastDisplay: index === frameOptionDisplays.length - 1
            })">
              <span :class="b('button', { top: true })" v-if="index > 0">
                <a-button
                  type="primary"
                  size="small"
                  :class="b('arrow')"
                  @click.stop="updateDisplayPosition([
                    {
                      id: item.id,
                      position: index - 1,
                    },
                    {
                      id: frameOptionDisplays[index - 1].id,
                      position: index,
                    },
                  ])"
                >
                  <template #icon>
                    <LeftOutlined />
                  </template>
                </a-button>
              </span>
              <span
                :class="b('button', { bottom: true })"
                v-if="index !== frameOptionDisplays.length - 1"
              >
                <a-button
                  type="primary"
                  size="small"
                  :class="b('arrow')"
                  @click.stop="updateDisplayPosition([
                    {
                      id: item.id,
                      position: index + 1,
                    },
                    {
                      id: frameOptionDisplays[index + 1].id,
                      position: index,
                    },
                  ])"
                >
                  <template #icon>
                    <RightOutlined />
                  </template>
                </a-button>
              </span>
            </span>
          </button>
        </div>
        <div :class="b('display-buttons')">
          <a-modal :open="showModal" :footer="null" width="200px" @cancel="toggleModal(false, '')">
            <UploadImages
                :is-multiple="false"
                v-model:files="files"
            />
            <div :class="b('modal-buttons')">
              <a-button
                  type="primary"
                  size="small"
                  html-type="button"
                  @click="toggleModal(false, '')"
              >
                Cancel
              </a-button>
              <a-button
                  type="primary"
                  size="small"
                  html-type="button"
                  @click="addImage"
              >
                Submit
              </a-button>
            </div>
          </a-modal>
          <template v-if="isShowOptions">
            <h4 :class="b('section-title')">Display Settings</h4>
            <div :class="b('modal-input')">
              <span>Name</span>
              <a-input
                  type="text"
                  v-model:value="name"
              />
            </div>
            <div :class="b('row', { margin: true })">
              <div :class="b('toggle')">
                <span :class="b('input-title')">Table/Wall</span>
                <a-switch
                    checked-children="On table"
                    un-checked-children="On wall"
                    v-model:checked="isTable"
                />
              </div>
              <div :class="b('toggle')">
                <span :class="b('input-title')">Default ?</span>
                <a-switch
                    checked-children="Yes"
                    un-checked-children="No"
                    v-model:checked="isDefault"
                />
              </div>
            </div>
            <div :class="b('divider')" />
            <h4 :class="b('section-title')">Images</h4>
            <a-button
                :class="b('modal-btn', { upload: true })"
                @click="toggleModal(true, 'baseImageUri')"
            >
              <upload-outlined />
              Upload background
            </a-button>
            <a-button
                :class="b('modal-btn', { upload: true })"
                @click="toggleModal(true, 'frameImageUri')"
            >
              <upload-outlined />
              Upload frame image
            </a-button>
            <a-button
                v-if="frameImageUri.url && selectedOption.name !== 'photo_art'"
                :class="b('modal-btn')"
                type="primary"
                @click="addFrameImageViewBox"
            >
              Add frame view box
            </a-button>
            <div :class="b('divider')" />
            <h4 :class="b('section-title')">Actions</h4>
            <a-button
                :class="b('modal-btn', { save: true })"
                v-if="selectedDisplay && selectedDisplay.id"
                @click="saveDisplay"
                :disabled="!name"
            >
              Save display
            </a-button>
            <a-button
                :class="b('modal-btn')"
                type="primary"
                :disabled="!name || !frameImageUri.url || !baseImageUri.url"
                @click="createDisplay"
            >
              Create display
            </a-button>
          </template>
          <template v-else>
            <h4 :class="b('section-title')">Text Zones</h4>
            <div :class="b('personalize-list')">
              <div
                :class="b('personalize-btn-wrap', {
                  dragging: draggedIndex === index,
                  dragover: dragOverIndex === index
                })"
                v-for="(item, index) in frameDisplayPersonalize"
                :key="item.id"
                draggable="true"
                @dragstart="onPersonalizeDragStart(index)"
                @dragover="onPersonalizeDragOver($event, index)"
                @dragleave="onPersonalizeDragLeave"
                @drop="onPersonalizeDrop($event, index)"
            >
              <a-button
                  :class="b('personalize-btn')"
                  :type="item.id === selectedPersonalize.id? 'primary' : 'default'"
                  @click="selectPersonalize(item)"
              >
                {{item.name}}
              </a-button>
              <a-popconfirm
                  :class="b('personalize-delete-btn')"
                  title="Sure to delete?"
                  @confirm="deletePersonalize(item)"
              >
                <a-button type="primary" size="middle" html-type="button" danger>
                  <DeleteOutlined />
                </a-button>
              </a-popconfirm>
              <a-button
                  :class="b('personalize-zoom-btn')"
                  @click="() => {
                    selectPersonalizeScale(item);
                  }"
                  v-if="selectedPersonalize.id && selectedPersonalize.id === item.id"
              >
                <ZoomInOutlined />
              </a-button>
            </div>
            </div>
            <div :class="b('divider')" />
            <h4 :class="b('section-title')">Actions</h4>
            <a-button
                :class="b('personalize-btn')"
                @click="addPersonalize"
            >Add new text zone</a-button>
            <a-button
                :class="b('personalize-btn')"
                type="primary"
                @click="savePersonalize"
            >Save personalize</a-button>
          </template>
        </div>
      </div>
    </div>
    <div :class="b('center')">
      <div
          :class="b('main-container')"
          :style="{
            backgroundImage: `url(${baseImageUri.url || ''})`,
            scale,
            transform: `translateX(${zoomLeft}px) translateY(${zoomTop}px)`
          }"
      >
        <DraggableResizableVue
            v-if="isShowOptions"
            :class="b('liveDisplay')"
            v-model:x="display.liveDisplay.x"
            v-model:y="display.liveDisplay.y"
            :h="display.liveDisplay.height"
            :w="display.liveDisplay.width"
            v-model:active="display.liveDisplay.active"
            :lock-aspect-ratio="activeType.type === 'liveDisplay' ? !isInputFocus : true"
            :parent="true"
            handles-type="borders"
            :onResize="onResizingDisplay"
            @activated="setActiveType('liveDisplay')"
        />
        <DraggableResizableVue
            v-if="isShowOptions"
            :class="b('minDisplay')"
            v-model:x="display.minDisplay.x"
            v-model:y="display.minDisplay.y"
            :h="display.minDisplay.height"
            :w="display.minDisplay.width"
            v-model:active="display.minDisplay.active"
            :lock-aspect-ratio="activeType.type === 'minDisplay' ? !isInputFocus : true"
            :parent="true"
            :onResize="onResizingDisplay"
            handles-type="borders"
            @activated="setActiveType('minDisplay')"
        />
        <DraggableResizableVue
            v-if="isShowOptions"
            :class="b('mobileDisplay')"
            v-model:x="display.mobileDisplay.x"
            v-model:y="display.mobileDisplay.y"
            :h="display.mobileDisplay.height"
            :w="display.mobileDisplay.width"
            v-model:active="display.mobileDisplay.active"
            :lock-aspect-ratio="activeType.type === 'mobileDisplay' ? !isInputFocus : true"
            :parent="true"
            :onResize="onResizingDisplay"
            handles-type="borders"
            @activated="setActiveType('mobileDisplay')"
        />
        <template v-if="scale === 1 && !isShowOptions">
          <template v-for="(personalize, index) in frameDisplayPersonalize">
            <DraggableResizableVue
                v-if="selectedPersonalize.id && selectedPersonalize.id === personalize.id"
                :class="b('personalize-wrap')"
                :key="personalize.id"
                :w="personalize.frameDisplayData.width"
                :h="personalize.frameDisplayData.height"
                v-model:x="personalize.frameDisplayData.x"
                v-model:y="personalize.frameDisplayData.y"
                v-model:active="personalize.frameDisplayData.active"
                :z="10"
                handles-type="borders"
                :handles="['mr']"
                :onResize="(handle, x, y, width, height) => {
                  personalizeOnChange({
                    handle,
                    x,
                    y,
                    width,
                    height,
                  }, 'personalizeData')
                }"
            >
              <span
                  :class="b('personalize-wrap-mobile')"
                  :style="{
                    width: `${personalize.frameDisplayData.width}px`,
                    height: `${personalize.frameDisplayData.height * 1.33}px`,
                    top: `-${
                      ((personalize.frameDisplayData.height * 1.33)
                       - personalize.frameDisplayData.height
                      )
                    }px`,
                  }"
              />
              <span
                  :class="b('view-box-number')"
                  :style="{
                  display: `${scale === 1 ? 'block' : 'none'}`,
                }"
              >{{ `#${index + 1}` }}</span>
            </DraggableResizableVue>
          </template>
        </template>
        <template v-if="isShowOptions">
          <DraggableResizableVue
              v-if="!isRatioLocked"
              :class="b(`framePosition`)"
              v-model:x="display.framePosition.x"
              v-model:y="display.framePosition.y"
              :h="display.framePosition.height"
              :w="display.framePosition.width"
              v-model:active="display.framePosition.active"
              :onResize="onResizingFrame"
              :parent="true"
              handles-type="borders"
              :draggable="frameActive"
              :resizable="frameActive"
              @activated="setActiveType('framePosition')"
              @mousedown="setActiveType('framePosition')"
          >
            <img
                :class="b('display-frame-image')"
                :style="{
                width: `${display.framePosition.width}px`,
                height: `${display.framePosition.height}px`
              }"
                :src="frameImageUri.url"
                alt="frame image"

            />
            <template
                v-for="(imageOption, index) in display.frameImageOptions"
                :key="imageOption.id"
            >
              <div
                  :style="{
                perspectiveOrigin: `
                ${otherSettings.framePerspectiveOriginX}%
                ${otherSettings.framePerspectiveOriginY}%
                `,
                height: `100%`,
                perspective: `${otherSettings.framePerspective}px`
              }"
              >
                <DraggableResizableVue
                    :class="b('frame-image')"
                    v-model:h="imageOption.height"
                    v-model:w="imageOption.width"
                    v-model:active="imageOption.active"
                    handles-type="borders"
                    :active-on-hover="true"
                    :style="{
                  top: `${imageOption.y}px`,
                  left: `${imageOption.x}px`,
                  'background-image': `url(${getBackgroundImage(imageOption?.imageId)})`,
                  transform: `
                  rotateX(${otherSettings.frameRotateX}deg)
                  rotateY(${otherSettings.frameRotateY}deg)
                  rotateZ(${otherSettings.frameRotateZ}deg)
                  `
                }"
                    @dragging="(x, y) => onDragImageOption(x, y, imageOption.id)"
                    @click.stop="setActiveType('frameImageOptions', imageOption.id)"
                    @mousedown.stop="setActiveType('frameImageOptions', imageOption.id)"
                >
                  <span :class="b('view-box-number')">{{ `#${index + 1}` }}</span>
                  <a-button
                      v-if="index !== 0"
                      :class="b('view-box-btn')"
                      type="primary"
                      size="small"
                      html-type="button"
                      @click="removeFrameImageViewBox(imageOption.id)"
                      danger
                  >
                    <DeleteOutlined />
                  </a-button>
                </DraggableResizableVue>
              </div>
            </template>
          </DraggableResizableVue>
          <DraggableResizableVue
              v-if="isRatioLocked"
              :class="b(`framePosition`)"
              v-model:x="display.framePosition.x"
              v-model:y="display.framePosition.y"
              v-model:h="display.framePosition.height"
              v-model:w="display.framePosition.width"
              v-model:active="display.framePosition.active"
              :lock-aspect-ratio="true"
              :parent="true"
              handles-type="borders"
              :draggable="frameActive"
              :resizable="frameActive"
              @activated="setActiveType('framePosition')"
              @mousedown="setActiveType('framePosition')"
          >
            <img
                :class="b('display-frame-image')"
                :style="{
                width: `${display.framePosition.width}px`,
                height: `${display.framePosition.height}px`
              }"
                :src="frameImageUri.url"
                alt="frame image"

            />
            <template
                v-for="(imageOption, index) in display.frameImageOptions"
                :key="imageOption.id"
            >
              <div
                  :style="{
                perspectiveOrigin: `
                ${otherSettings.framePerspectiveOriginX}%
                ${otherSettings.framePerspectiveOriginY}%
                `,
                height: `100%`,
                perspective: `${otherSettings.framePerspective}px`
              }"
              >
                <DraggableResizableVue
                    :class="b('frame-image')"
                    v-model:h="imageOption.height"
                    v-model:w="imageOption.width"
                    v-model:active="imageOption.active"
                    handles-type="borders"
                    :active-on-hover="true"
                    :style="{
                  top: `${imageOption.y}px`,
                  left: `${imageOption.x}px`,
                  'background-image': `url(${getBackgroundImage(imageOption?.imageId)})`,
                  transform: `
                  rotateX(${otherSettings.frameRotateX}deg)
                  rotateY(${otherSettings.frameRotateY}deg)
                  rotateZ(${otherSettings.frameRotateZ}deg)
                  `
                }"
                    @dragging="(x, y) => onDragImageOption(x, y, imageOption.id)"
                    @click.stop="setActiveType('frameImageOptions', imageOption.id)"
                    @mousedown.stop="setActiveType('frameImageOptions', imageOption.id)"
                >
                  <span :class="b('view-box-number')">{{ `#${index + 1}` }}</span>
                  <a-button
                      v-if="index !== 0"
                      :class="b('view-box-btn')"
                      type="primary"
                      size="small"
                      html-type="button"
                      @click="removeFrameImageViewBox(imageOption.id)"
                      danger
                  >
                    <DeleteOutlined />
                  </a-button>
                </DraggableResizableVue>
              </div>
            </template>
          </DraggableResizableVue>
        </template>
        <div
            :style="{
                position: 'absolute',
                left: `${display.framePosition.x}px`,
                top: `${display.framePosition.y}px`,
                width: `${display.framePosition.width}px`,
                height: `${display.framePosition.height}px`
              }"
            v-else
        >
          <img
              :class="b('display-frame-image')"
              :style="{
                width: `${display.framePosition.width}px`,
                height: `${display.framePosition.height}px`
              }"
              :src="frameImageUri.url"
              alt="frame image"

          />
          <template v-if="scale !==1">
            <template v-for="(personalize) in frameDisplayPersonalize" :key="personalize.id">
              <DraggableResizableVue
                  v-if="selectedPersonalize.id && selectedPersonalize.id === personalize.id"
                  :class="b('personalize')"
                  :key="personalize.id"
                  v-model:w="personalize.width"
                  v-model:h="personalize.height"
                  v-model:x="personalize.x"
                  v-model:y="personalize.y"
                  v-model:active="personalize.active"
                  handles-type="borders"
                  :scale="scale"
              >
                <DraggableResizableVue
                    :class="b('frame-personalize-option')"
                    v-model:h="personalize.framePersonalizeOptions.height"
                    v-model:w="personalize.framePersonalizeOptions.width"
                    v-model:x="personalize.framePersonalizeOptions.x"
                    v-model:y="personalize.framePersonalizeOptions.y"
                    :active="personalize.framePersonalizeOptions.active"
                    :handles="['mr', 'bm', 'br']"
                    handles-type="borders"
                    :scale="scale"
                    @mousedown.stop="setPersonalizeOptionsActive"
                    @activated="setPersonalizeOptionsActive"
                >
                  <div :class="b('personalize-text-wrap')" :style="{
                    justifyContent: `${personalize.verticalAlignment}`,
                  }">
                    <div
                        :class="b('personalize-text')"
                        v-for="text in personalize.lines"
                        :key="text.id"
                        :style="{
                          fontSize: `${personalize.fontSize}px`,
                          fontWeight: `${personalize.fontWeight}`,
                          color: `${personalize.fontColor}`,
                          fontFamily: `${personalize.fontFamily}`,
                          alignSelf: `${personalize.alignment}`,
                          textTransform: `${personalize.isUppercase ? 'uppercase' : 'none'}`,
                        }"
                    >{{text.value}}</div>
                  </div>
                </DraggableResizableVue>
              </DraggableResizableVue>
            </template>
          </template>
        </div>
      </div>
    </div>
    <a-drawer
      :open="isSettingsDrawerOpen"
      placement="left"
      :width="420"
      :closable="false"
      :mask="false"
      :class="b('settings-drawer')"
      :get-container="false"
      :style="{ position: 'absolute' }"
      @close="closeSettingsDrawer"
    >
      <div :class="b('drawer-header')">
        <h4 :class="b('settings-title')">
          {{ drawerTitle }}
        </h4>
        <a-button
          type="text"
          :class="b('drawer-close')"
          @click="closeSettingsDrawer"
        >
          <template #icon><close-outlined /></template>
        </a-button>
      </div>
      <div :class="b('drawer-content')">
        <template v-if="Object.keys(selectedPersonalize).length > 0 && !isShowOptions">
          <TemplateFrameOptionPersonalizeSettings
              :frame-display-personalize="frameDisplayPersonalize"
              :selectedPersonalize="selectedPersonalize"
              :on-change="personalizeOnChange"
              :scale="scale"
          />
        </template>
        <template v-else-if="activeType.type">
          <a-select
              :options="displayList"
              :value="activeType.name"
              style="width: 100%; margin-bottom: 16px"
              @change="setActiveType"
          />
          <TemplateFrameOptionDisplaySettings
              v-if="activeType.imageOptionId === 0"
              v-model:x="display[activeType.type].x"
              v-model:y="display[activeType.type].y"
              v-model:width="display[activeType.type].width"
              v-model:height="display[activeType.type].height"
              v-model:isRatioLocked="isRatioLocked"
              v-model:isInputFocus="isInputFocus"
              :activeType="activeType"
          />
          <TemplateFrameImageOptionsSettings
              v-else
              :frame-image-options="display.frameImageOptions"
              v-model:frameRotateX="otherSettings.frameRotateX"
              v-model:frameRotateY="otherSettings.frameRotateY"
              v-model:frameRotateZ="otherSettings.frameRotateZ"
              v-model:framePerspective="otherSettings.framePerspective"
              v-model:framePerspectiveOriginX="otherSettings.framePerspectiveOriginX"
              v-model:framePerspectiveOriginY="otherSettings.framePerspectiveOriginY"
          />
        </template>
      </div>
    </a-drawer>
  </div>
</template>

<style scoped lang="scss" src="./templateFrameOptionDisplays.scss"></style>
